"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1809],{

/***/ 46319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22934);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Index = function(param) {
    var Component = param.Component, list = param.list, _divisionWidth = param.divisionWidth, divisionWidth = _divisionWidth === void 0 ? 200 : _divisionWidth;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), activeCount = ref[0], setActiveCount = ref[1];
    var carousalRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleScroll = function() {
        var ref;
        if (carousalRef === null || carousalRef === void 0 ? void 0 : (ref = carousalRef.current) === null || ref === void 0 ? void 0 : ref.scrollLeft) {
            var ref1;
            var count = Math === null || Math === void 0 ? void 0 : Math.floor((carousalRef === null || carousalRef === void 0 ? void 0 : (ref1 = carousalRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollLeft) / divisionWidth);
            if (count >= 0) setActiveCount(count + 1);
            else setActiveCount(1);
        } else setActiveCount(1);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("section", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().staticCarousal),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().carousalContainer),
                ref: carousalRef,
                onScroll: function() {
                    return handleScroll();
                },
                children: list === null || list === void 0 ? void 0 : list.map(function(carousalItem, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().carousalItem),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(Component, {
                            carousalItem: carousalItem
                        })
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tracker),
                children: list.map(function(_, i) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: "".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().trackerDot), " ").concat(activeCount === i + 1 ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().activeDot) : "")
                    }, _ === null || _ === void 0 ? void 0 : _.name);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Index);


/***/ }),

/***/ 26245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22934);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79354);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25935);






var Index = function(param) {
    var carousalItem = param.carousalItem;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().testimonialCard),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().testimonialCardHead),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().avatar),
                        style: {
                            backgroundImage: "url(".concat(carousalItem === null || carousalItem === void 0 ? void 0 : carousalItem.avatar_url, ")")
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().customerDetails),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().customerName),
                            children: carousalItem === null || carousalItem === void 0 ? void 0 : carousalItem.name
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__/* .ASSETS.BLUE_TICK */ .ou.BLUE_TICK,
                        height: "16px",
                        width: "16px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().customerFeedback),
                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(carousalItem === null || carousalItem === void 0 ? void 0 : carousalItem.feedback)
            })
        ]
    }, carousalItem === null || carousalItem === void 0 ? void 0 : carousalItem.name);
};
/* harmony default export */ __webpack_exports__["Z"] = (Index);


/***/ }),

/***/ 51809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36584);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40706);
/* harmony import */ var _common_StaticCarousal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46319);
/* harmony import */ var _common_TestimonialCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26245);






var Index = function() {
    var ref;
    var testimonial_section = _config__WEBPACK_IMPORTED_MODULE_2__/* .LANDING_PAGE_DATA.testimonial_section */ .BF.testimonial_section;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("section", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().testimonialsSection),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sectionTitle),
                    style: {
                        marginBottom: "unset"
                    },
                    children: [
                        testimonial_section.title,
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().customerSupportHighlight),
                            children: testimonial_section.colored_text
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_common_StaticCarousal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                Component: _common_TestimonialCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                list: (ref = _config__WEBPACK_IMPORTED_MODULE_2__/* .LANDING_PAGE_DATA.testimonial_section */ .BF.testimonial_section) === null || ref === void 0 ? void 0 : ref.customer_list
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

}]);